function NRLicenseIssuesIconX({ height = '24', width = '24', color = 'currentColor' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" focusable="false">
      <path
        d="M15.5352 7.87891L13.4141 10L15.5352 12.1211L14.1211 13.5352L12 11.4141L9.87891 13.5352L8.46484 12.1211L10.5859 10L8.46484 7.87891L9.87891 6.46484L12 8.58594L14.1211 6.46484L15.5352 7.87891Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C14.2333 2 16.1248 2.7752 17.6748 4.3252C19.2248 5.8752 20 7.76667 20 10C20 11.0167 19.8246 11.975 19.4746 12.875C19.1246 13.7749 18.6333 14.5754 18 15.2754V23L12 21L6 23V15.2754C5.3667 14.5754 4.87539 13.7749 4.52539 12.875C4.17539 11.975 4 11.0167 4 10C4 7.76667 4.7752 5.8752 6.3252 4.3252C7.8752 2.7752 9.76667 2 12 2ZM16 16.9248C15.4167 17.2581 14.7873 17.5212 14.1123 17.7129C13.4374 17.9045 12.7332 18 12 18C11.2668 18 10.5626 17.9045 9.8877 17.7129C9.2127 17.5212 8.58333 17.2581 8 16.9248V20.0254L12 19L16 20.0254V16.9248ZM12 4C10.3333 4 8.91667 4.58333 7.75 5.75C6.58333 6.91667 6 8.33333 6 10C6 11.6667 6.58333 13.0833 7.75 14.25C8.91667 15.4167 10.3333 16 12 16C13.6667 16 15.0833 15.4167 16.25 14.25C17.4167 13.0833 18 11.6667 18 10C18 8.33333 17.4167 6.91667 16.25 5.75C15.0833 4.58333 13.6667 4 12 4Z"
        fill={color}
      />
    </svg>
  );
}
export default NRLicenseIssuesIconX;
